(() => {
  'use strict';
  const drawer = document.querySelector('cart-drawer');
  if (!drawer || drawer.dataset.bbBalancedObserver) return;
  drawer.dataset.bbBalancedObserver = 'true';

  function disclose(container, label) {
    const options = Array.from(container.children).filter(node =>
      !node.matches('[data-bb-delivery-summary], .bb-cart-item-meta__product-title')
    );
    const secondary = options.slice(2).filter(node => node.textContent.trim().toLowerCase() !== 'blank');
    if (secondary.length < 2) return;
    const details = document.createElement('details');
    details.className = 'bb-cart-options';
    const summary = document.createElement('summary');
    summary.textContent = label;
    details.append(summary);
    const values = document.createElement('div');
    values.className = 'bb-cart-options__values';
    secondary.forEach(node => values.append(node));
    details.append(values);
    const delivery = container.querySelector(':scope > [data-bb-delivery-summary]');
    container.insertBefore(details, delivery);
  }

  function moveActions(media, destination, label) {
    const existing = media.querySelector('.bb-cart-item-media-action');
    const preview = media.querySelector('button[data-lightbox-src]');
    if (!existing && !preview) return;
    const actions = document.createElement('div');
    actions.className = 'bb-cart-balanced-actions';
    if (preview) {
      const view = document.createElement('button');
      view.type = 'button';
      view.className = 'bb-open-designer bb-cart-preview-link';
      view.textContent = label;
      view.addEventListener('click', () => preview.click());
      actions.append(view);
    }
    if (existing) actions.append(existing);
    destination.append(actions);
  }

  function enhance(row) {
    if (row.dataset.bbBalanced) return;
    const primary = row.querySelector('.bb-cart-item-primary');
    const media = row.querySelector('.cart-item__media');
    if (!primary || !media) return;
    row.dataset.bbBalanced = 'true';
    const root = row.closest('#CartDrawer');
    const optionsLabel = root?.dataset.bbOptionsLabel || 'All options';
    const previewLabel = root?.dataset.bbPreviewLabel || 'View design';
    const meta = primary.querySelector('.bb-cart-item-meta');
    const titles = meta ? Array.from(meta.querySelectorAll(':scope > .bb-cart-item-meta__product-title')) : [];
    if (titles.length) {
      const artwork = Array.from(media.querySelectorAll('.bb-cart-item-media-product'));
      titles.forEach(title => {
        const group = document.createElement('section');
        group.className = 'bb-cart-component';
        group.setAttribute('aria-label', title.textContent.trim());
        const info = document.createElement('div');
        info.className = 'bb-cart-component__info';
        const config = document.createElement('div');
        config.className = 'bb-cart-component__options';
        let sibling = title.nextElementSibling;
        while (sibling && !sibling.matches('.bb-cart-item-meta__product-title, [data-bb-delivery-summary]')) {
          const next = sibling.nextElementSibling;
          config.append(sibling);
          sibling = next;
        }
        title.before(group);
        info.append(title, config);
        const componentMedia = artwork.find(node => node.dataset.bbCartComponentKey === title.dataset.bbCartComponentKey);
        if (componentMedia) {
          group.append(componentMedia);
          moveActions(componentMedia, info, previewLabel);
          group.classList.add('bb-cart-component--with-media');
        }
        // Title and options precede the existing artwork controls in keyboard order.
        info.insertBefore(config, info.querySelector('.bb-cart-balanced-actions'));
        group.append(info);
        disclose(config, optionsLabel);
      });
      if (!media.children.length) row.classList.add('bb-cart-item--components');
    } else {
      if (meta) disclose(meta, optionsLabel);
      moveActions(media, primary, previewLabel);
    }
  }

  function refresh() {
    drawer.querySelectorAll('.cart-item:not([data-bb-balanced])').forEach(enhance);
  }
  refresh();
  new MutationObserver(refresh).observe(drawer, {childList:true, subtree:true});
})();
